import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/admin/login";
import { ProtectedPassRoute } from "./protectedRoute";

import ForgotPassword from "../pages/admin/forgotPassword";
import ChangePassword from "../pages/admin/changePassword";
import { AuthPassProvider } from "../utils/passwordContext";
import ContentRoute from "./contentRoute";
import PrivacyPolicy from "../componets/privacyPolicy";
import DeleteAccountProcedure from "../componets/deleteAccourt";
import Support from "../pages/admin/support";

export default function Navigation() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/delete-account" element={<DeleteAccountProcedure />} />
      <Route path="/support" element={<Support />} />

      <Route
        path="/forgot-password"
        element={
          <AuthPassProvider>
            <ForgotPassword />
          </AuthPassProvider>
        }
      />
      <Route
        path="/change-password"
        element={
          <AuthPassProvider>
            <ProtectedPassRoute>
              <ChangePassword />
            </ProtectedPassRoute>
          </AuthPassProvider>
        }
      />
 <Route path="*" element={<ContentRoute/>} />
    </Routes>
  );
}
 